<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box p-0">
        <a routerLink="/dashboard" class="logo logo-dark">
          <span class="logo-sm">
            <img [src]="wl.logoSmallUrl" [alt]="wl.appName" height="20" />
          </span>
          <span class="logo-lg">
            <img [src]="wl.logoUrl" [alt]="wl.appName" height="50" />
          </span>
        </a>
        <a routerLink="/dashboard" class="logo logo-light">
          <span class="logo-sm">
            <img [src]="wl.logoSmallUrl" [alt]="wl.appName" height="20" />
          </span>
          <span class="logo-lg">
            <img [src]="wl.logoUrl" [alt]="wl.appName" height="50" />
          </span>
        </a>
      </div>

      <button
        type="button"
        class="btn btn-sm px-3 font-size-16 header-item"
        id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)"
      >
        <i class="fa fa-fw fa-bars"></i>
      </button>
    </div>

    <div class="d-flex align-items-center gap-3">
      <!-- Seletor de Prestador de Serviço (apenas para ADMINISTRATOR) -->
      <div
        class="d-flex align-items-center gap-2"
        *ngIf="profile === 'ADMINISTRATOR'"
      >
        <i
          class="fas fa-sync-alt refresh-icon"
          (click)="getServiceProviders()"
          [title]="'TOPBAR.REFRESH_SERVICE_PROVIDERS' | translate"
          style="cursor: pointer"
        ></i>

        <ng-select
          class="custom-ngselect w-100"
          [items]="serviceProviders"
          bindLabel="name"
          bindValue="serviceProviderId"
          [ngModel]="serviceProviderIdSelected"
          (ngModelChange)="onServiceProviderChange($event)"
          [placeholder]="'TOPBAR.SELECT_SERVICE_PROVIDER' | translate"
          [clearable]="false"
        >
        </ng-select>
      </div>

      <!-- Tela cheia -->
      <is-button
        variant="ghost"
        size="sm"
        shape="circle"
        icon="bx-fullscreen"
        [tooltip]="'TOPBAR.FULLSCREEN' | translate"
        (clicked)="fullscreen()"
      ></is-button>

      <!-- Idioma (acesso rápido) -->
      <div class="dropdown d-none d-sm-inline-block" ngbDropdown>
        <button
          type="button"
          class="topbar-btn"
          ngbDropdownToggle
          id="page-header-lang-dropdown"
        >
          <img [src]="flagvalue" [alt]="countryName" height="16" width="22" style="border-radius:2px;" />
        </button>
        <div class="dropdown-menu dropdown-menu-end topbar-lang-dropdown" ngbDropdownMenu>
          <a
            *ngFor="let item of listLang"
            href="javascript:void(0);"
            class="dropdown-item d-flex align-items-center gap-2 py-2"
            (click)="setLanguage(item.text, item.lang, item.flag, item.value)"
            [class.active]="cookieValue === item.lang"
          >
            <img [src]="item.flag" [alt]="item.text" height="14" width="20" style="border-radius:2px;" />
            <span>{{ item.text }}</span>
            <i *ngIf="cookieValue === item.lang" class="bx bx-check ms-auto text-success"></i>
          </a>
        </div>
      </div>

      <!-- Notificações de Processamento -->
      <div class="dropdown d-inline-block" ngbDropdown>
        <button
          type="button"
          class="topbar-btn position-relative"
          ngbDropdownToggle
          id="page-header-notifications-dropdown"
          (click)="onNotificationBellClick()"
        >
          <i class="bx bx-bell"></i>
          <span class="topbar-badge" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end topbar-notif-dropdown p-0" ngbDropdownMenu>
          <div class="topbar-notif-dropdown__header">
            <span class="fw-semibold">{{ 'PROCESSING_LOG.NOTIFICATIONS' | translate }}</span>
            <div class="d-flex gap-2">
              <a href="javascript:void(0);" class="small" (click)="clearAllNotifications()" *ngIf="recentLogs.length > 0">
                {{ 'PROCESSING_LOG.CLEAR_ALL' | translate }}
              </a>
              <a href="javascript:void(0);" class="small" (click)="markAllNotificationsAsRead()" *ngIf="unreadCount > 0">
                {{ 'PROCESSING_LOG.MARK_ALL_READ' | translate }}
              </a>
            </div>
          </div>
          <div class="topbar-notif-dropdown__list">
            <a
              *ngFor="let log of recentLogs"
              href="javascript:void(0);"
              class="topbar-notif-dropdown__item"
              [ngClass]="{ 'bg-light': !log.isRead }"
              (click)="onNotificationClick(log)"
            >
              <div class="topbar-notif-dropdown__icon"
                [ngClass]="{
                  'bg-danger-subtle text-danger': log.status === 2,
                  'bg-warning-subtle text-warning': log.status === 3,
                  'bg-success-subtle text-success': log.status === 1,
                  'bg-info-subtle text-info': log.status === 4
                }">
                <i class="bx"
                  [ngClass]="{
                    'bx-x': log.status === 2,
                    'bx-error': log.status === 3,
                    'bx-check': log.status === 1,
                    'bx-minus': log.status === 4
                  }"></i>
              </div>
              <div class="topbar-notif-dropdown__content">
                <p class="topbar-notif-dropdown__title">{{ 'PROCESSING_LOG.ACTION.' + log.action | translate }}</p>
                <p class="topbar-notif-dropdown__msg">{{ log.messageDescription || log.messageCode }}</p>
                <p class="topbar-notif-dropdown__ref" *ngIf="log.routeId || log.serviceOrderTrackerId">
                  <span *ngIf="log.routeId">{{ 'PROCESSING_LOG.REF.ROUTE' | translate }}: #{{ log.routeId }}</span>
                  <span *ngIf="log.routeId && log.serviceOrderTrackerId"> · </span>
                  <span *ngIf="log.serviceOrderTrackerId">{{ 'PROCESSING_LOG.REF.SERVICE_ORDER' | translate }}: #{{ log.serviceOrderTrackerId }}</span>
                </p>
              </div>
              <span class="topbar-notif-dropdown__time">{{ log.dtCreation | date:'dd/MM HH:mm' }}</span>
              <button class="topbar-notif-dropdown__dismiss" (click)="dismissNotification(log, $event)" title="{{ 'PROCESSING_LOG.DISMISS' | translate }}">
                <i class="bx bx-x"></i>
              </button>
            </a>
            <div *ngIf="recentLogs.length === 0" class="p-3 text-center text-muted">
              {{ 'PROCESSING_LOG.NO_NOTIFICATIONS' | translate }}
            </div>
          </div>
          <div class="topbar-notif-dropdown__footer" *ngIf="isAdmin">
            <a href="javascript:void(0);" routerLink="/processing-logs">
              <i class="mdi mdi-arrow-right-circle me-1"></i> {{ 'PROCESSING_LOG.VIEW_ALL' | translate }}
            </a>
          </div>
        </div>
      </div>

      <!-- Dropdown Usuário -->
      <div class="dropdown d-inline-block" ngbDropdown>
        <button
          type="button"
          class="topbar-btn"
          ngbDropdownToggle
          id="page-header-user-dropdown"
        >
          <img
            class="rounded-circle"
            src="../../../assets/images/users/avatar-wkf.svg"
            [alt]="'TOPBAR.AVATAR_ALT' | translate"
            width="28"
            height="28"
          />
        </button>

        <div class="dropdown-menu dropdown-menu-end topbar-user-dropdown p-0" ngbDropdownMenu>
          <!-- User header -->
          <div class="topbar-user-dropdown__header">
            <img
              class="rounded-circle"
              src="../../../assets/images/users/avatar-wkf.svg"
              [alt]="'TOPBAR.AVATAR_ALT' | translate"
              width="40"
              height="40"
            />
            <div>
              <p class="topbar-user-dropdown__name">{{ username }}</p>
              <p class="topbar-user-dropdown__role">{{ profile }}</p>
            </div>
          </div>

          <!-- Tema -->
          <div class="topbar-user-dropdown__section">
            <a class="topbar-user-dropdown__item" href="javascript:void(0);" (click)="toggleTheme()">
              <i [class]="'bx ' + themeIcon"></i>{{ themeLabel }}
            </a>
          </div>

          <!-- Idioma -->
          <div class="topbar-user-dropdown__section">
            <a
              class="topbar-user-dropdown__item"
              href="javascript:void(0);"
              (click)="langExpanded = !langExpanded"
            >
              <img [src]="flagvalue" [alt]="countryName" height="14" width="20" style="border-radius:2px;" />
              {{ countryName }}
              <i class="bx ms-auto" [class.bx-chevron-down]="!langExpanded" [class.bx-chevron-up]="langExpanded" style="font-size:0.85rem;"></i>
            </a>
            <div *ngIf="langExpanded" class="topbar-user-dropdown__lang-list">
              <a
                *ngFor="let item of listLang"
                href="javascript:void(0);"
                class="topbar-user-dropdown__item topbar-user-dropdown__item--sub"
                (click)="setLanguage(item.text, item.lang, item.flag, item.value); langExpanded = false"
                [class.topbar-user-dropdown__item--active]="cookieValue === item.lang"
              >
                <img [src]="item.flag" [alt]="item.text" height="14" width="20" style="border-radius:2px;" />
                {{ item.text }}
                <i *ngIf="cookieValue === item.lang" class="bx bx-check ms-auto text-success"></i>
              </a>
            </div>
          </div>

          <!-- Sair -->
          <div class="topbar-user-dropdown__section topbar-user-dropdown__section--danger">
            <a class="topbar-user-dropdown__item" href="javascript:void(0);" (click)="logout()">
              <i class="bx bx-power-off"></i>{{ "MENU.LOGOUT" | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
